import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardColumnRQ } from './model/DashboardColumnRQ';
import { DashboardColumnRS } from './model/DashboardColumnRS';
import { endpoints } from '../../../environments/endpoint';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AppDashboardColumnStampService {

  constructor(private http: HttpClient) { }

  convertDataIso(requestDSolum: DashboardColumnRQ): void {
    let arrayStringDSolum: string[] = [];

    arrayStringDSolum = requestDSolum.dtVoo.split('/');

    requestDSolum.dtVoo = arrayStringDSolum[2] + '-' + arrayStringDSolum[1] + '-' + arrayStringDSolum[0] + 'T00:00:00';
  }

  getDataByDate(requestDSolum: DashboardColumnRQ): Observable<DashboardColumnRS[]> {

    if (!requestDSolum.dtVoo.includes('T')) {
      this.convertDataIso(requestDSolum);
    }

    let params1 = new HttpParams().set('flightBeginDate', requestDSolum.dtVoo);

    return this.http.get<DashboardColumnRS[]>(endpoints.REST_GET_STAMP_GROUP_BY_ORIGIN_SYSTEM+"?"+params1, httpOptions);
  }

}
